import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const getCloudMigrationInfo = (mpacBaseUrl, appKey) => fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/").concat(appKey, "/migration")).then(response => response.json()).catch(error => {
  if (error.status === 404) return null;
  throw error;
});
export const getBulkCloudMigrationInfo = (mpacBaseUrl, addons) => fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/migration/bulkfetch"), {
  method: 'POST',
  body: JSON.stringify(addons),
  headers: {
    'Content-Type': 'application/json'
  }
}).then(response => response.json()).catch(error => {
  throw error;
});
export const updateDualLicenseOptInState = (mpacBaseUrl, appKey, dualLicenseOptInState) => {
  const requestBody = [{
    op: 'replace',
    path: '/isDualLicenseOptedIn',
    value: dualLicenseOptInState
  }];
  return fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/").concat(appKey, "/migration"), {
    method: 'PATCH',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json-patch+json'
    }
  }).then(response => response.json()).catch(error => {
    throw error;
  });
};